import React from 'react';

class AvatarImg extends React.Component {
  render() {
    if (this.props.src) {
      return (
        <img
          className="rounded-circle mr-3 ml-0 avatar-common-header"
          alt="Avatar"
          src={this.props.src}
          height="118"
          width="118"
        />
      );
    }
    return (
      <div className="icon-wrapper">
        <i className="icon-profile avatar" />
      </div>
    );
  }
}

export default AvatarImg;
